import * as React from "react";
interface Props {
    children: React.ReactNode,
}

export default function Error(props: Props) {

    return(
        <section className="error">
            <p>{props.children}</p>
        </section>
    )
}
